__turbopack_context__.v({
  "AngleTitlesAndIcons": "GraphicDivider-module-sass-module__i1eT9q__AngleTitlesAndIcons",
  "Column": "GraphicDivider-module-sass-module__i1eT9q__Column",
  "Cont": "GraphicDivider-module-sass-module__i1eT9q__Cont",
  "GraphicDivider": "GraphicDivider-module-sass-module__i1eT9q__GraphicDivider",
  "Image": "GraphicDivider-module-sass-module__i1eT9q__Image",
  "Title": "GraphicDivider-module-sass-module__i1eT9q__Title",
  "Video": "GraphicDivider-module-sass-module__i1eT9q__Video",
});
